// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"6b3ae9ea","138":"025b68e8","557":"cfd998e8","593":"7eac99cf"}[chunkId] + ".chunk.js";
};